import { Component, Input } from '@angular/core';
import { IMachineFromApi, IDocumentationFile } from 'app/models';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-documentation-component',
  templateUrl: './documentation.component.html',
  styleUrls: ['./documentation.component.scss'],
})
export class DocumentationComponent {
  @Input()
  listOfMachinesFromApi: Array<IMachineFromApi> = [];

  selectedMachine: IMachineFromApi | null = null;

  customerDocumentationFiles: IDocumentationFile[] = [
    { name: 'Dichiarazione CE', fileName: 'ce-declaration.pdf', fileType: 'pdf' },
    { name: 'Documento di garanzia', fileName: 'warranty.pdf', fileType: 'pdf' },
    { name: 'Documentazione tecnica configurazione', fileName: 'technical-config-1.pdf', fileType: 'pdf' },
    { name: 'Manuale d\'uso e manutenzione', fileName: 'user-manual.pdf', fileType: 'pdf' },
    { name: 'Schemi elettrici', fileName: 'electrical-schematics.pdf', fileType: 'pdf' },
    { name: 'Certificazioni', fileName: 'certifications.pdf', fileType: 'pdf' },
  ];

  internalDocumentationFiles: IDocumentationFile[] = [
    { name: 'Firmware della macchina', fileName: 'firmware.zip', fileType: 'zip' },
    { name: 'Parametri macchina al collaudo', fileName: 'test-parameters.zip', fileType: 'zip' },
    { name: 'Installer HMI', fileName: 'hmi-installer.zip', fileType: 'zip' },
  ];

  handleSelectedMachineChange(selectedMachineId?: number): void {
    if (selectedMachineId != null) {
      this.selectedMachine =
        this.listOfMachinesFromApi.find(
          (machine) => machine.id === selectedMachineId
        ) || null;
    } else {
      this.selectedMachine = null;
    }
  }

  getFileUrl(file: IDocumentationFile): string {
    if (!this.selectedMachine) {
      return '';
    }
    // eslint-disable-next-line max-len
    return `https://storage.cloud.google.com/${environment.documentationBucket}/${this.selectedMachine.customerId}/${this.selectedMachine.id}/${file.fileName}`;
  }

  getFileIcon(fileType: 'pdf' | 'zip'): string {
    return fileType === 'pdf' ? 'picture_as_pdf' : 'folder_zip';
  }

  openFile(file: IDocumentationFile): void {
    const url = this.getFileUrl(file);
    window.open(url, '_blank');
  }
}
